export const ENTITY_OVERVIEW_URL = '/vceptpl/csr/entityOverview.do';
export const EDIT_OTHER_ACCOUNT_ROLES = '/vceptpl/csr/acctmaint/editOtherAcctRoles.do';
export const EDIT_SUCCESSION_PLAN = '/vceptpl/csr/acctmaint/editSuccessionPlan.do';
export const POPULATE_STANDING_LOA = '/vceptpl/csr/populateStandingLoa.do';
export const EDIT_ACCOUNT_NAME = '/vceptpl/csr/acctmaint/editAccountName.do';